<template>
  <div>
    <Header :title="title" />
    <div class="content">
      <p><b>请上传银行流水单或存款回执单的清晰图片或视频，以方便快速上分。</b></p>
      <p>图片或视频含完整姓名、卡号、金额、银行印章、收支明细等。</p>

      <div class="upload">
        <div v-if="showUploaded" class="media-container">
          <div v-for="uploadedUrlFile in uploadedUrlFiles" :key="uploadedUrlFile.url" class="medium-container">
            <img
              v-if="uploadedUrlFile.file.type.includes('image')"
              class="photo"
              :src="uploadedUrlFile.url"
              @click="clickImagePreview(uploadedUrlFile)"
            >
            <video
              v-if="uploadedUrlFile.file.type.includes('video')"
              class="video"
              @click="clickVideoPreview(uploadedUrlFile)"
            >
              <source :src="uploadedUrlFile.url" :type="uploadedUrlFile.file.type">
            </video>
            <img class="close" src="@/assets/images/template/toolbar_close1.png" @click="closedelePop(uploadedUrlFile)">
          </div>
        </div>
        <input id="upload-input" ref="inputMultiple" type="file" accept="image/*,video/*" @change="multipleChange()">
        <label v-if="!isMaxUpload()" class="upload-btn" for="upload-input">+</label>
        <span v-if="isImageFormatError" class="error">图片格式只支持{{ supportedImageFormats.join('、') }}</span>
        <span v-if="isImageSizeError" class="error">图片单张大小不能超过{{ maxImageInMb }}MB</span>
        <span v-if="isMaxImagesError" class="error">最多可上传 {{ maxImagesAmt }} 张图片</span>
        <span v-if="isVideoFormatError" class="error">视频格式只支持{{ supportedVideoFormats.join('、') }}</span>
        <span v-if="isVideoSizeError" class="error">视频总大小不能超过{{ maxVideoInMb }}MB</span>
        <span v-if="isMaxVideosError" class="error">最多可上传 {{ maxVideosAmt }} 段视频</span>
      </div>

      <p>图片格式支持{{ supportedImageFormats.join('、') }}，单张大小不超过{{ maxImageInMb }}MB, 总大小不超过{{ maxImageInMb * maxImagesAmt }}MB。</p>
      <p>视频格式支持{{ supportedVideoFormats.join('、') }}，总大小不超过{{ maxVideoInMb }}MB。</p>
    </div>

    <div class="btnItem">
      <span class="confirm" :class="uploadedUrlFiles.length > 0 ? 'suc' : ''" @click="submit()">确认上传</span>
    </div>

    <!--删除照片-->
    <div v-if="isDelePop" class="popFixed">
      <div class="masking" @click="closedelePop" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p>请确认要删除此图片</p>
        </div>
        <div class="btnCon">
          <span @click="closedelePop">取消</span>
          <span @click="deleImg">删除</span>
        </div>
      </div>
    </div>

    <!--预览图片-->
    <div v-if="isPreviewImagePop" class="popFixed">
      <div class="masking" @click="closeImagePreview" />
      <img class="preview" :src="previewPic">
    </div>

    <!--预览视频-->
    <div v-if="isPreviewVideoPop" class="popFixed">
      <div class="masking" @click="closeVideoPreview" />
      <video class="preview" controls>
        <source :src="previewVideo">
      </video>
    </div>

    <AlertPop
      :model="alertPop.show"
      :content="alertPop.content"
      :button1Txt="alertPop.button1Txt"
      :button1Evt="alertOnClose"
      @alertOnClose="alertOnClose"
    />
  </div>
</template>

<script>
require('@/assets/css/uploadDocuments.css')
import Header from '@/view/module/Header.vue'
import api from '@/plugins/api'
import AlertPop from '@/view/module/AlertPop.vue'
export default {
  name: 'UploadDocuments',
  components: { Header, AlertPop },
  data() {
    return {
      supportedImageFormats: ['.png', '.jpg', '.jpeg'],
      supportedVideoFormats: ['.mpg', '.mod', '.mmv', '.tod', '.wmv', '.asf', '.avi', '.divx', '.mov',
        '.m4v', '.3gp', '.3g2', '.mp4', '.m2t', '.m2ts', '.mts', '.mkv'],
      mbInBytes: 1048576,
      maxImageInMb: 2,
      maxVideoInMb: 20,
      maxImagesAmt: 5,
      maxVideosAmt: 1,
      title: '存取款记录',
      showUploaded: false,
      isDelePop: false,
      pendingDelUrlFile: '',
      uploadedUrlFiles: [],
      isPreviewImagePop: false,
      previewPic: '',
      isPreviewVideoPop: false,
      previewVideo: '',
      isImageFormatError: false,
      isImageSizeError: false,
      isVideoFormatError: false,
      isVideoSizeError: false,
      isMaxImagesError: false,
      isMaxVideosError: false,
      result: this.$route.query.result || '',
      pno: this.$route.query.pno || '',
      customerno: this.$route.query.customerno || '',
      payAmount: this.$route.query.payAmount || '',
      createDate: this.$route.query.createDate || '',
      msg: decodeURIComponent(this.$route.query.msg).replace(/\+/g, ' ') || '',
      alertPop: {
        show: false
      },
      from: this.$route.query.from || ''
    }
  },
  watch: {
    $route(to, from) {
      this.showUploaded = false
      this.uploadedUrlFiles = []
    }
  },
  methods: {
    multipleChange() {
      let url
      const inputMultiple = this.$refs.inputMultiple
      if (inputMultiple.files) {
        this.showUploaded = true
        for (const file of inputMultiple.files) {
          this.isMaxImagesError = false
          this.isMaxVideosError = false
          this.isImageFormatError = false
          this.isImageSizeError = false
          this.isVideoFormatError = false
          this.isVideoSizeError = false

          if (file.type.includes('image')) {
            if (this.isMaxImages() || !this.checkImage(file)) return
          } else {
            if (this.isMaxVideos() || !this.checkVideo(file)) return
          }

          url = URL.createObjectURL(file)
          if (file.type.includes('video')) {
            this.uploadedUrlFiles = [...this.uploadedUrlFiles, { url: url, file: file }]
            return
          }
          this.compressImg(file, url)
        }
      }
    },
    compressImg(file, url) {
      if (file.size / 1024 > 1025) { // 大于1M，进行压缩上传
        this.photoCompress(file, { quality: 0.2 }, file.name, url)
      } else {
        this.uploadedUrlFiles = [...this.uploadedUrlFiles, { url: url, file: file }]
      }
    },
    photoCompress(file, w, name, url) {
      const ready = new FileReader()
      /* 开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
      ready.readAsDataURL(file)
      const _this = this
      ready.onload = function(e) {
        const path = e.target.result
        _this.canvasDataURL(path, w, name, url)
      }
    },
    canvasDataURL(path, obj, name, url) {
      const _this = this
      const img = new Image()
      img.src = path
      img.onload = function() {
        const that = this
        // 默认按比例压缩
        let w = that.width
        let h = that.height
        const scale = w / h
        w = obj.width || w
        h = obj.height || (w / scale)
        let quality = 0.7 // 默认图片质量为0.7
        // 生成canvas
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        // 创建属性节点
        const anw = document.createAttribute('width')
        anw.nodeValue = w
        const anh = document.createAttribute('height')
        anh.nodeValue = h
        canvas.setAttributeNode(anw)
        canvas.setAttributeNode(anh)
        ctx.drawImage(that, 0, 0, w, h)
        // 图像质量
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
          quality = obj.quality
        }
        // quality值越小，所绘制出的图像越模糊
        const base64 = canvas.toDataURL('image/jpeg', quality)
        // 回调函数返回base64的值
        _this.uploadedUrlFiles = [..._this.uploadedUrlFiles, { url: url, file: _this.dataURLtoFile(base64, name) }]
      }
    },
    // base64转换为file
    dataURLtoFile(base64, filename) { // 将base64转换为文件
      var arr = base64.split(','); var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1]); var n = bstr.length; var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    closedelePop(uploadedUrlFile) {
      this.isDelePop = !this.isDelePop
      document.getElementById('upload-input').value = null
      this.pendingDelUrlFile = uploadedUrlFile
    },
    deleImg() {
      this.isDelePop = !this.isDelePop
      this.uploadedUrlFiles = this.uploadedUrlFiles.filter(uploadedUrlFile => uploadedUrlFile.url != this.pendingDelUrlFile.url)
      if (this.uploadedUrlFiles.length == 0) {
        this.showUploaded = false
      }

      this.pendingDelUrlFile = ''
    },
    checkImage(file) {
      const extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      const AllUpExt = `|${this.supportedImageFormats.join('|')}|`
      if (AllUpExt.indexOf(extName + '|') == '-1') {
        this.isImageFormatError = true
        return false
      } else if (file.size > this.maxImageInMb * this.mbInBytes) {
        this.isImageSizeError = true
        return false
      }

      return true
    },
    checkVideo(file) {
      const extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      const AllUpExt = `|${this.supportedVideoFormats.join('|')}|`
      if (AllUpExt.indexOf(extName + '|') == '-1') {
        this.isVideoFormatError = true
        return false
      } else if (file.size > this.maxVideoInMb * this.mbInBytes) {
        this.isVideoSizeError = true
        return false
      }

      return true
    },
    isMaxImages() {
      if (this.uploadedUrlFiles.filter(file => file.file.type.includes('image')).length + 1 > this.maxImagesAmt) {
        this.isMaxImagesError = true
        return true
      }

      return false
    },
    isMaxVideos() {
      if (this.uploadedUrlFiles.filter(file => file.file.type.includes('video')).length + 1 > this.maxVideosAmt) {
        this.isMaxVideosError = true
        return true
      }

      return false
    },
    clickImagePreview(uploadedUrlFile) {
      this.previewPic = uploadedUrlFile.url
      this.isPreviewImagePop = !this.isPreviewImagePop
    },
    closeImagePreview() {
      this.isPreviewImagePop = !this.isPreviewImagePop
    },
    clickVideoPreview(uploadedUrlFile) {
      this.previewVideo = uploadedUrlFile.url
      this.isPreviewVideoPop = !this.isPreviewVideoPop
    },
    closeVideoPreview() {
      this.isPreviewVideoPop = !this.isPreviewVideoPop
    },
    isMaxUpload() {
      return this.uploadedUrlFiles.length > this.maxVideosAmt + this.maxImagesAmt
    },
    submit() {
      if (this.uploadedUrlFiles.length <= 0) {
        return
      }

      const fileFormData = new FormData()
      const attachments = this.uploadedUrlFiles.map(urlFile => urlFile.file)
      fileFormData.append('pno', this.pno)
      for (let i = 0; i < attachments.length; i++) {
        fileFormData.append('attachments', attachments[i])
      }
      this.$bus.$emit('loading', false)
      api.uploadAttachments(fileFormData).then(res => {
        this.$bus.$emit('loading', true)
        if (res.data.code == 200) {
          const confirmDepositParam = {
            pno: this.pno
          }
          const data = this.$qs.stringify(confirmDepositParam)
          this.$bus.$emit('loading', false)
          api.confirmDeposit(data).then((res) => {
            this.$bus.$emit('loading', true)
            if (res.data.code == 200) {
              if (this.result == '') {
                this.$router.go(-1)
              } else {
                this.$router.push({ path: '/home/rechargeResult', query: { result: this.result, pno: this.pno, customerno: this.customerno, payAmount: this.payAmount, createDate: this.createDate, msg: this.msg }})
              }
            } else if (res.data.code == 500) {
              this.alertPop = {
                show: true,
                content: res.data.code_desc,
                button1Txt: '知道了'
              }
            }
          })
        } else if (res.data.code == 500) {
          this.alertPop = {
            show: true,
            content: res.data.code_desc,
            button1Txt: '知道了'
          }
        }
      })
    },
    alertOnClose() {
      this.alertPop.show = false
      if (this.result == '') {
        if (this.from == 'record') {
          this.$router.replace({ path: '/home/record' })
          return
        }

        this.$router.go(-1)
      }
    }
  }
}
</script>
